<script>
    import Star from "./Star.svelte";

    export let rating = 0;
    export let outOf = 5;

    let starsFilled = new Array(outOf)
        .fill(false)
        .fill(true, 0, rating);
</script>

<div>
    {#each starsFilled as filled}
        <Star {filled} />
    {/each}
</div>

<style>
    div {
        display: flex;
        margin-bottom: 0.5rem;
    }
</style>
